// extracted by mini-css-extract-plugin
export default {"icon":"Icon_icon__2d7dP","iconFont":"Icon_iconFont__sBLOn"};